import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { fundTeaser } from '@/content/homepage';
import { assetUrl } from '@/lib/asset-url';

export function FundTeaser() {
  return (
    <section
      aria-labelledby="fund-heading"
      className="px-4 pb-20 sm:px-6 sm:pb-28 lg:px-8"
    >
      <div className="border-border relative mx-auto w-full max-w-7xl overflow-hidden rounded-2xl border bg-card shadow-[0_24px_60px_-40px_rgb(20_23_31_/_0.35)]">
        <div className="absolute inset-0" aria-hidden>
          <img
            src={assetUrl(fundTeaser.image.src)}
            alt=""
            className="h-full w-full object-cover object-center opacity-40"
            loading="lazy"
            decoding="async"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-card via-card/92 to-card/55" />
          <div className="absolute inset-0 bg-gradient-to-t from-card via-transparent to-card/30" />
        </div>

        <div className="relative grid gap-10 px-6 py-12 sm:px-10 sm:py-16 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,0.8fr)] lg:items-end lg:px-14 lg:py-20">
          <div>
            <p className="text-primary mb-4 text-xs font-semibold tracking-[0.24em] uppercase">
              {fundTeaser.eyebrow}
            </p>
            <h2
              id="fund-heading"
              className="font-display text-foreground max-w-3xl text-3xl font-semibold tracking-tight text-balance sm:text-4xl lg:text-5xl"
            >
              {fundTeaser.heading}
            </h2>
            <p className="text-muted-foreground mt-5 max-w-2xl text-base leading-relaxed sm:text-lg">
              {fundTeaser.body}
            </p>
            <p className="text-foreground/90 mt-4 max-w-2xl text-sm leading-relaxed sm:text-base">
              {fundTeaser.vision}
            </p>

            <div className="mt-9 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center">
              {fundTeaser.ctas.map((cta) => {
                const isExternal = 'external' in cta && cta.external;
                const content = isExternal ? (
                  <a href={cta.href} target="_blank" rel="noreferrer noopener">
                    {cta.label}
                    <span className="sr-only">(opens in new tab)</span>
                  </a>
                ) : (
                  <Link to={cta.href}>{cta.label}</Link>
                );

                if (cta.variant === 'link') {
                  return (
                    <Button
                      key={cta.id}
                      asChild
                      variant="link"
                      className="text-primary h-auto justify-start px-0 text-sm"
                    >
                      {content}
                    </Button>
                  );
                }

                return (
                  <Button key={cta.id} asChild size="lg" variant={cta.variant} className="sm:min-w-56">
                    {content}
                  </Button>
                );
              })}
            </div>
          </div>

          <figure className="border-border hidden overflow-hidden rounded-xl border bg-background lg:block">
            <img
              src={assetUrl(fundTeaser.image.src)}
              alt={fundTeaser.image.alt}
              className="aspect-[4/3] w-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </figure>
        </div>
      </div>
    </section>
  );
}
